export const EditorLanguages = {
	'java7': {
		label: 'Java',
		editorLanguage: 'java'
	},
	'java8': {
		label: 'Java',
		editorLanguage: 'java'
	},
	'javascript': {
		label: 'JavaScript',
		editorLanguage: 'javascript'
	},
	'php': {
		label: 'PHP',
		editorLanguage: 'php'
	},
	'nodejs': {
		label: 'Node.js',
		editorLanguage: 'javascript'
	},
	'python': {
		label: 'Python',
		editorLanguage: 'python'
	},
	'c++': {
		label: 'C++',
		editorLanguage: 'c_cpp'
	},
	'c#': {
		label: 'C#',
		editorLanguage: 'csharp'
	},
	'ruby': {
		label: 'Ruby',
		editorLanguage: 'ruby'
	},
	'scala': {
		label: 'Scala',
		editorLanguage: 'scala'
	},
	'clojure': {
		label: 'Clojure',
		editorLanguage: 'clojure'
	}
};



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/constants/editor-languages.ts